import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; // ← імпорт Link

export default function HeaderNavigation() {
    const { t } = useTranslation();

    const navLinks = [
        { title: t("home.nav.about"), href: "/about" },
        { title: t("home.nav.news"), href: "/news" },
        // { title: t("home.nav.projects"), href: "/projects" },
        { title: t("home.nav.education"), href: "/educational-materials" },
        // { title: t("home.nav.cooperation"), href: "/cooperation" },
        // { title: t("home.nav.forum"), href: "/forum" },
    ];

    return (
        <nav className="hidden xl:flex gap-6 text-base text-text-300 leading-none w-full text-left pl-7">
            <ul className="flex gap-6 items-center">
                {navLinks.map((link) => (
                    <li key={link.title}>
                        <Link
                            to={link.href} // ← замість href
                            className="block px-2 transition-colors duration-300 hover:text-primary-400"
                        >
                            {link.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
